import React from "react";
import shop from "shop/shop";
import { Button, Table } from "semantic-ui-react";
import Collapsible                                                                    from 'react-collapsible';

export function ProductDownloads( { product } ) {
  const [resources, setResources] = React.useState( false )
  const [loading, setLoading] = React.useState( false )
  React.useEffect( () => {
    async function load() {
      setLoading( true )
      let res = await shop.fetch( `/shop/rest/data/v1/article/resources/${product.map_id}` )
      setResources( res )
      setLoading( false )
    }
    
    load()
  }, [product] )
  
  //console.log("resources",resources)
  return <div>
    {loading && <br/>}
    {!loading && resources && resources.length > 0 && <div>
      <Collapsible tabIndex={0} trigger="Datenblätter">
									<p>
									{ <div className="pt3 pt4-ns">
                    <table>
          <colgroup>

          </colgroup>
          <tbody>
            <tr>
            {resources && resources.map( filePackage => {
                  return <td className="pa3 fw6" key={filePackage.content}>
                    {filePackage.map_id.endsWith("Sicherheitsdatenblatt") ? "Sicherheitsdatenblatt" :
                     filePackage.map_id.endsWith("TechnischesDatenblatt") ? "Technisches Datenblatt" :
                     filePackage.map_id.endsWith("Montageanleitung") ? "Montageanleitung" :
                     filePackage.map_id.endsWith("Zertifikate") ? "Zertifikate" : "Datenblatt"}
                  </td>} )}
            </tr>
            <tr>
            {resources && resources.map( filePackage => {
                    return <td className="pl3 pr3 fw6" key={filePackage.content}>
                      <Button basic size={"tiny"} as={"a"} target={"_blank"} download={`${filePackage.content}`}
                        href={`${shop.config.API}data/v1/article/resources/${product.map_id}/${encodeURI(filePackage.map_id)}`}>Datei herunterladen</Button>
                    </td>} )}
            </tr>
          </tbody>
        </table>
									</div>}
									</p>
									</Collapsible>
  {/*<div >
          {/*<h4>{translate( "Produktdatenblatt" )}</h4>*/}
          {/*<Table basic={"very"}>
            <Table.Body>
              <Table.Row>
                {console.log("resources filepackage",resources)}
                {resources && resources.map( filePackage => {
                  return <div key={filePackage.content}>
                    <Table.Cell>
                      {console.log("filepackage",filePackage)}
                                      <Button basic size={"tiny"} as={"a"} target={"_blank"} download={filePackage.content}
                          href={`${shop.config.API}data/v1/article/resources/${product.map_id}/${encodeURI(filePackage.map_id)}`}>Datei herunterladen</Button>
                         </Table.Cell>
                  </div>} )}
              </Table.Row>
            </Table.Body>
          </Table>}
        </div>*/}
    </div>}
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/hvz/components/ProductDownloads.js